var map = {
	"./Burger.svg": "e023",
	"./Daylight.svg": "88c6",
	"./Night.svg": "ef07",
	"./Running.svg": "4b27",
	"./change.svg": "9440",
	"./edit.svg": "daf0",
	"./label.svg": "765c",
	"./left.svg": "2b80",
	"./money.svg": "cf44",
	"./right.svg": "37af",
	"./stat.svg": "cdd6",
	"./weight.svg": "b676"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";